import { render, staticRenderFns } from "./BrandLayout.vue?vue&type=template&id=3e703b2e&scoped=true&"
import script from "./BrandLayout.vue?vue&type=script&lang=js&"
export * from "./BrandLayout.vue?vue&type=script&lang=js&"
import style0 from "./BrandLayout.vue?vue&type=style&index=0&id=3e703b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e703b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e703b2e')) {
      api.createRecord('3e703b2e', component.options)
    } else {
      api.reload('3e703b2e', component.options)
    }
    module.hot.accept("./BrandLayout.vue?vue&type=template&id=3e703b2e&scoped=true&", function () {
      api.rerender('3e703b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/BrandLayout.vue"
export default component.exports